

import { Flex, Input, Select } from "antd";
import Link from "next/link";
import Image from "next/image";
import { useState, useEffect, Suspense } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { useRouter } from 'nextjs-toploader/app';
import SearchUpload from "../AliUpload/search_upload";
import { encryptData } from "@/lib/utils";

const { Option } = Select;

export default function SearchBar() {

    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const [selectData, setSelectData] = useState('products');

    const [searchKey, setSearchKey] = useState('');


    useEffect(() => {
        // 当路径是搜索页时从URL初始化状态
        if (pathname === '/search') {
            const type = searchParams.get('type') || 'products';
            const key = searchParams.get('searchKey') || '';
            setSearchKey(type === 'identifying' ? '' : key);
            setSelectData(type === 'identifying' ? 'products' : type);
        } else {
            // 离开搜索页时重置状态
            setSelectData('products');
            setSearchKey('');
        }
    }, [pathname, searchParams]);


    const selectBefore = (
        <Select value={selectData == 'identifying' ? 'products' : selectData} style={{ width: 110 }} onChange={(value) => setSelectData(value)}>
            <Option value="products">Products</Option>
            <Option value="suppliers">Suppliers</Option>
        </Select>
    )


    const handleSearch = () => {

        let type = selectData;
        if (selectData == 'identifying') {
            type = 'products'
        }

        router.push(`/search?type=${type}&searchKey=${searchKey}`)
    }

    const handleUploadDone = url => {
        // 重置输入框和下拉框状态
        setSelectData('products');
        setSearchKey('');
        router.push(`/search?type=identifying&searchKey=${encryptData(url)}`)
    }

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Flex align="center" justify="center" flex={1} className="search_bar_bx">
                <Flex align="center" className="search_bx" flex={1}>
                    <Input
                        type="text"
                        placeholder={`Search for ${selectData}`}
                        className="search_input"
                        addonBefore={selectBefore}
                        onChange={(e) => setSearchKey(e.target.value)}
                        value={searchKey}
                        onPressEnter={handleSearch}
                    />
                    <SearchUpload handleUploadDone={handleUploadDone} />
                    <Flex align="center" justify="center" className="search_btn" onClick={handleSearch}>Search</Flex>
                </Flex>
                <Link className='header_bar_item bar_item_rfq' href='/rfq' target="_blank">
                    <Flex align='center' justify='center' style={{ height: 30 }}>
                        <Image src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/icon_rfq.png" alt='rfq' width={26} height={25} />
                    </Flex>
                    <p>Post my RFQ</p>
                </Link>
            </Flex>
        </Suspense>
    );
}